var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pages",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "g2048Page page",
    class: _vm.isMobile && 'wap',
    style: {
      backgroundImage: `url(${require(`@images/${_vm.theme}/inset-bg-1.jpg`)})`
    }
  }, [_c('div', {
    staticClass: "game-box gap-10"
  }, [_c('div', {
    staticClass: "game-top-box relative flex items-center justify-between"
  }, [_c('div', {
    staticClass: "flex gap-10"
  }, [_c('div', [_c('div', {
    staticClass: "bg-white/80 rounded"
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Score')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.gameState.score))])])])]), _c('div', {
    staticClass: "gap-10"
  }, [_c('div', {
    staticClass: "time-box"
  }, [_c('div', {
    staticClass: "time-count"
  }, [_vm._v(_vm._s(_vm._f("formatHour")(_vm.leftTime)))]), _c('div', {
    staticClass: "time-text"
  }, [_vm._v(_vm._s(_vm.$lang('Award and reset after countdown.')))])])]), _c('div', [_c('div', {
    staticClass: "bg-white/80 rounded relative",
    on: {
      "click": _vm.viewRank
    }
  }, [_c('span', {
    staticClass: "text-xs font-bold"
  }, [_vm._v(_vm._s(_vm.$lang('Prize Pool')))]), _c('div', {
    staticClass: "text-xl font-bold text-green",
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/${_vm.theme}/earn-key.png`),
      "width": "18",
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.prizePool))])])])]), _c('div', {
    ref: "gameCenterBox",
    staticClass: "game-center-box flex-1"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_c('div', {
    ref: "gameCenterBoxInner",
    staticClass: "inner-box relative",
    on: {
      "touchstart": _vm.handleTouchStart,
      "touchend": _vm.handleTouchEnd
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-4 grid-rows-4 gap-3 h-full w-full"
  }, _vm._l(16, function (i) {
    return _c('div', {
      key: i,
      staticClass: "bg-zinc-200/50 rounded-lg w-full h-full"
    });
  }), 0), _c('div', {
    staticClass: "absolute inset-0 p-3 pointer-events-none"
  }, [_c('div', {
    staticClass: "relative w-full h-full"
  }, _vm._l(_vm.gameState.tiles, function (tile) {
    return _c('div', {
      key: tile.id,
      ref: "tiles",
      refInFor: true,
      staticClass: "tile absolute w-1/4 h-1/4 p-1.5",
      style: {
        left: 0,
        top: 0,
        transform: `translate(${tile.x * 100}%, ${tile.y * 100}%)`,
        zIndex: Math.log2(tile.value)
      },
      attrs: {
        "data-id": tile.id
      }
    }, [_c('div', {
      staticClass: "inner-tile w-full h-full rounded-lg flex items-center justify-center text-2xl font-bold shadow-sm",
      class: _vm.getTileColor(tile.value),
      attrs: {
        "data-inner-id": `${tile.id}-${tile.value}`
      }
    }, [_vm._v(" " + _vm._s(tile.value) + " ")])]);
  }), 0)])])]), _c('div', {
    staticClass: "grid grid-cols-3 gap-3",
    staticStyle: {
      "margin": "0 auto",
      "width": "60%"
    }
  }, [_c('div'), _c('button', {
    staticClass: "bg-zinc-200 p-2 rounded-lg flex justify-center active:bg-zinc-300",
    on: {
      "click": function ($event) {
        return _vm.handleMove('up');
      }
    }
  }, [_c('svg-icon', {
    staticStyle: {
      "transform": "rotate(-90deg)"
    },
    attrs: {
      "name": "icon-arrow"
    }
  })], 1), _c('div'), _c('button', {
    staticClass: "bg-zinc-200 p-2 rounded-lg flex justify-center active:bg-zinc-300",
    on: {
      "click": function ($event) {
        return _vm.handleMove('left');
      }
    }
  }, [_c('svg-icon', {
    staticStyle: {
      "transform": "rotate(-180deg)"
    },
    attrs: {
      "name": "icon-arrow"
    }
  })], 1), _c('button', {
    staticClass: "bg-zinc-200 p-2 rounded-lg flex justify-center active:bg-zinc-300",
    on: {
      "click": function ($event) {
        return _vm.handleMove('down');
      }
    }
  }, [_c('svg-icon', {
    staticStyle: {
      "transform": "rotate(90deg)"
    },
    attrs: {
      "name": "icon-arrow"
    }
  })], 1), _c('button', {
    staticClass: "bg-zinc-200 p-2 rounded-lg flex justify-center active:bg-zinc-300",
    on: {
      "click": function ($event) {
        return _vm.handleMove('right');
      }
    }
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1)])])]), _c('pop-game-warn-prompt', {
    attrs: {
      "show": _vm.popOpenMobileShow,
      "message": _vm.$lang(`Please open this page on your mobile phone.`),
      "btnConfirmText": _vm.$lang('Back')
    },
    on: {
      "update:show": function ($event) {
        _vm.popOpenMobileShow = $event;
      },
      "confirm": function ($event) {
        return _vm.$router.back();
      }
    }
  }), _c('pop-game-start-prompt', {
    attrs: {
      "show": _vm.popStartShow,
      "message": _vm.$lang(`<li>Earn rewards by playing.</li>
<li>The higher your rank, the greater your reward.</li>
<li>Play multiple times within the countdown. Only your highest score will count for ranking.</li>
<li>All players will reset and start over once the countdown ends.</li>`)
    },
    on: {
      "update:show": function ($event) {
        _vm.popStartShow = $event;
      },
      "confirm": function ($event) {
        return _vm.initGame();
      }
    }
  }), _c('pop-game-lost-prompt', {
    attrs: {
      "show": _vm.popLostShow,
      "title": _vm.$lang('Game over'),
      "message": _vm.$lang('Going beyond the limit, game over.'),
      "cancelText": _vm.revives > 0 ? _vm.$lang('Give up') : _vm.$lang('Restart (Score Resets)'),
      "confirmText": _vm.revives > 0 ? _vm.$lang(`Revive (${_vm.revives}/${_vm.maxRevives})`) : _vm.$lang('Restart')
    },
    on: {
      "update:show": function ($event) {
        _vm.popLostShow = $event;
      },
      "cancel": _vm.handleCancel,
      "confirm": function ($event) {
        return _vm.handleConfirm();
      }
    }
  }), _c('pop-game-user-reward-prompt', {
    attrs: {
      "show": _vm.popUserRewardShow,
      "title": _vm.$lang('Congratulations')
    },
    on: {
      "update:show": function ($event) {
        _vm.popUserRewardShow = $event;
      },
      "confirm": _vm.handleGetRewardConfirm
    }
  }), _c('pop-game-rank', {
    attrs: {
      "gameType": '2048',
      "show": _vm.popGameRankShow
    },
    on: {
      "update:show": function ($event) {
        _vm.popGameRankShow = $event;
      }
    }
  })], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };